import * as $ from 'jquery'
import 'fitvids'
import 'svg4everybody'
import 'jquery.cycle2'
import './navigation'
import './init-headroom'
import './init-lightbox'
import './init-nearest-store'
import './init-where-box'
require('fix-outline')()
require('60fps-scroll-element')(document)

$('main').fitVids()



// WEBPACK FOOTER //
// ./sportspower/assets/es6/site.js